import { render, staticRenderFns } from "./ContactsApps.vue?vue&type=template&id=4ff18e88"
import script from "./ContactsApps.vue?vue&type=script&lang=js"
export * from "./ContactsApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports